export type EventType =
  | "project_status_changed"
  | "service_status_changed"
  | "document_status_changed";

export const EVENT_TYPE_OPTIONS: { value: EventType; label: string }[] = [
  { value: "project_status_changed", label: "Project Status Changed" },
  { value: "service_status_changed", label: "Service Status Changed" },
  { value: "document_status_changed", label: "Document Status Changed" },
];

export const eventTypeLabel = (value: string | null | undefined): string =>
  EVENT_TYPE_OPTIONS.find((o) => o.value === value)?.label ?? value ?? "";

export type PublicationStatus = "pending" | "success" | "error" | "duplicate";

export interface WebhookSubscription {
  id: string;
  webhookUrl: string;
  eventType: string;
}

export interface WebhookSubscriptionFormValues {
  webhookUrl: string;
  eventType: EventType | "";
}

export const emptyWebhookSubscriptionForm: WebhookSubscriptionFormValues = {
  webhookUrl: "",
  eventType: "",
};

export interface WebhookPublication {
  id: string;
  status: string;
  httpStatus: number | null;
  sourceType: string;
  sourceId: number | null;
  contents: unknown;
  createdAt: string;
}

export const WEBHOOK_SUBSCRIPTION_TYPE = "webhook-subscriptions";
